var map = {
	"./priority/logo priority-01.png": "b4fd",
	"./priority/logo priority-13.png": "3b72",
	"./priority/logo profile priority-66.jpg": "206a",
	"./priority/logo profile priority-74.jpg": "0bcc",
	"./priority/logo-mark.png": "71aa",
	"./priority/logo-wordmark.png": "258d",
	"./priority/logo.png": "e40a",
	"./priority/logo.svg": "e8bd",
	"./studenia/logo.png": "8a5c",
	"./studenia/logo.svg": "e3f6",
	"./superlatif/logo.png": "407f",
	"./superlatif/logo.svg": "2f6c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bf8e";